<!-- Shorthand variables -->
@let billing = billingOverview();
@let showSkeletons = !billing && billing !== 0;

<div class="bn-billing-overview">
  <a
    class="bn-billing-overview__link"
    routerLink="/account/billing"
    routerLinkActive="bn-billing-overview__link--active">
    <div class="bn-level">
      <div class="bn-level--left">
        <div>
          <fa-icon
            class="bn-billing-overview__icon"
            icon="credit-card" />Balance
        </div>
      </div>
      <div class="bn-level--right bn-billing-overview__amount">
        @if (showSkeletons) {
          <span class="bn-billing-overview__amount-skeleton">$---.--</span>
        } @else {
          {{ billing.Balance | currency }}
        }
      </div>
    </div>

    <div class="bn-billing-overview__progress-bar">
      <div
        class="bn-billing-overview__progress-bar__fill"
        [ngClass]="{
          'bn-billing-overview__progress-bar__fill--success': percentage > 35,
          'bn-billing-overview__progress-bar__fill--warning': percentage > 15 && percentage <= 35,
          'bn-billing-overview__progress-bar__fill--danger': percentage <= 15,
        }"
        [ngStyle]="{
          width: percentage + '%',
        }"></div>
    </div>
    @if (userTrial().inProgress) {
      <div
        class="bn-billing-overview__trial"
        container="body"
        containerClass="tooltip--white m-1"
        tooltip="Trial credits expire when your trial ends. Any unused credits will be lost.">
        <div class="d-flex justify-content-between mt-2 text-100-semi-bold">
          <div>Trial credits</div>
          <div>{{ userTrial().balance | currency: 'USD' : 'symbol' : '1.2' }}</div>
        </div>
        <div class="d-flex text-100-regular">{{ endsInText }}</div>
      </div>
    }
  </a>
</div>
